//import node_modules
import React, { Fragment, FunctionComponent, PropsWithChildren } from "react";
import { NextPage } from "next";
import { Container, Col, Row, Card, Button } from "react-bootstrap";
import NextImage from "next/legacy/image";
import NextLink from "next/link";

//import pages
// import { PageProps } from "../types";

//helpers
import getImageSrcHelper from "libs/helper/get-image-src";
import isUnoptimized from "libs/helper/get-is-unoptimized";
import { css, cx } from "libs/emotion";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import MetadataComponent from "./components/MetadataComponent";
import ParallaxComponent from "src/components/parallax-component";
import ParallaxHeaderComponent from "src/components/parallax-header-component";
import PageHeaderComponent from "src/components/PageHeaderComponent";
// import MapComponent from "src/components/map-component";

//types
import type { PageProps } from "./types";
import type { DestinationDocument } from "@adjust/libs/database/destinations";

import getBootstrapSizes from "libs/helper/get-bootstrap-sizes";

import previewImage from "@adjust/website/src/images/4c2bed6cd91ccff956ffddfb3c2a196e.png";

const sizes = getBootstrapSizes({ xs: 640, xl: 384 });

const hoverCSS = css({
  [":hover"]: {
    opacity: 0.7,
  },
});

const blockCSS = css({
  display: "inline-block",
  padding: "0.5rem 1rem",
  fontSize: "1.25rem",
  fontFamily: "Domine,sans-serif",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "black",
  textAlign: "center",
  textDecoration: "none",
  verticalAlign: "middle",
  userSelect: "none",
  border: "1px solid #d7e7ff",
  borderRadius: "0.5rem",
  backgroundColor: "#e6f0ff",
});

interface LocationProps {
  destination: DestinationDocument;
}

const LinkWrapperComponent: FunctionComponent<PropsWithChildren<LocationProps>> = ({ destination, children }) => {
  return <NextLink href={`/destinations/${destination.slug}/`} >{children}</NextLink>;
};

const DestinationComponent: FunctionComponent<LocationProps> = ({ destination }) => {
  return (
    <Col md={6} xl={4} className="d-flex flex-column p-3">
      <LinkWrapperComponent destination={destination}>
        <Card className={cx(hoverCSS, `h-100`)}>
          <NextImage
            src={getImageSrcHelper(destination.image) || previewImage}
            alt={destination.image.alt || destination.title}
            quality={destination.image.quality || 35}
            width={100}
            height={100}
            sizes={sizes}
            layout="responsive"
            objectFit="cover"
            unoptimized={isUnoptimized(destination.image)}
          />
          <Card.ImgOverlay className="d-flex flex-column p-0">
            <div className="mt-auto mx-5 text-center">
              <div className="d-grid gap-2">
                <div className={cx(blockCSS)}>{destination.title}</div>
              </div>
            </div>
          </Card.ImgOverlay>
        </Card>
      </LinkWrapperComponent>
    </Col>
  );
};

import bgImage from "src/images/5b1bfc9771211845f763f10c683d7d53.png";

const DestinationsPage: NextPage<PageProps> = ({ destinations: locations }) => {
  return (
    <SiteLayout>
      <MetadataComponent />
      <ParallaxComponent bgImage={bgImage} bgImageAlt="Destinations Parallax Image" strength={-300} priority>
        <ParallaxHeaderComponent size="sm">Journey to Extraordinary Destinations</ParallaxHeaderComponent>
      </ParallaxComponent>
      <Container className="my-5">
        <PageHeaderComponent type="h1" className="text-center">
          Discover Our Handpicked Travel Gems
        </PageHeaderComponent>
        <Row className="justify-content-center mt-4">
          {locations.map((destination, i) => (
            <DestinationComponent key={`${destination.title}:${i}`} destination={destination} />
          ))}
        </Row>
      </Container>
    </SiteLayout>
  );
};

export default DestinationsPage;
